import axios from 'axios'

export default {
  namespaced: true,
  state: {
    workClientProjectsResponsibleEmployeesGrid: [],
    workClientProjectsResponsibleEmployeesAll_project: [],
    workClientProjectsResponsibleEmployeesShow: null,
    pageData: null,
  },
  mutations: {
    setWorkClientProjectsResponsibleEmployeesGrid(state, payload) {
      state.workClientProjectsResponsibleEmployeesGrid = payload
    },
    setWorkClientProjectsResponsibleEmployeesAll_project(state, payload) {
      state.workClientProjectsResponsibleEmployeesAll_project = payload
    },
    setWorkClientProjectsResponsibleEmployeesShow(state, payload) {
      state.workClientProjectsResponsibleEmployeesShow = payload
    },
    setPageData(state, payload) {
      state.pageData = payload
    },
    setDefaultProjectsResponsibleEmployees(state) {
      ;(state.workClientProjectsResponsibleEmployeesGrid = []),
        (state.workClientProjectsResponsibleEmployeesAll_project = [])
    },
  },
  getters: {
    workClientProjectsResponsibleEmployeesGrid: (state) => {
      return state.workClientProjectsResponsibleEmployeesGrid
    },
    workClientProjectsResponsibleEmployeesAll_project: (state) => {
      return state.workClientProjectsResponsibleEmployeesAll_project
    },
    workClientProjectsResponsibleEmployeesShow: (state) => {
      return state.workClientProjectsResponsibleEmployeesShow
    },
    pageData: (state) => {
      return state.pageData
    },
  },
  actions: {
    onWorkClientProjectsResponsibleEmployeesGrid({ commit, rootState }, { limit, page }) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            rootState.apiDomain +
            '/api/admin/work/client/project/responsible/grid?limit=' +
            limit +
            '&page=' +
            page,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkClientProjectsResponsibleEmployeesGrid', resp.data.data)
            commit('setPageData', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkClientProjectsResponsibleEmployeesAll_project({ commit, rootState }, { project_id }) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            rootState.apiDomain +
            '/api/admin/work/client/project/responsible/grid?limit=0&filter[]=project_id:' +
            project_id,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkClientProjectsResponsibleEmployeesAll_project', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkClientProjectsResponsibleEmployeesShow({ commit, rootState }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/project/responsible/' + id,
          id: id,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkClientProjectsResponsibleEmployeesShow', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // onWorkClientProjectsResponsibleEmployeesCreate({ rootState }, { data }) {
    //   return new Promise((resolve, reject) => {
    //     axios({
    //       url: rootState.apiDomain + '/api/admin/work/client/project/responsible',
    //       data: data,
    //       method: 'POST',
    //     })
    //       .then((resp) => {
    //         resolve(resp)
    //       })
    //       .catch((err) => {
    //         reject(err)
    //       })
    //   })
    // },
    onWorkClientProjectsResponsibleEmployeesUpdate({ rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/project/responsible',
          data: data,
          method: 'PUT',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkClientProjectsResponsibleEmployeesDelete({ rootState }, { id }) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/project/responsible/' + id,
          id: id,
          method: 'DELETE',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
}
